<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <px-lista-requisicao-produto-list-options />
      <v-btn icon
             @click="onClickRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-lista-requisicao-produto-filtros @change="emitChange" />
      <px-search-text class="rounded-tag-small"
                      label="Busque por um produto, identificador, usuário ou código"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-lista-requisicao-produtos-selecionados :produtos="produtos"
                                               @remove="onRemove"/>
  </div>
</template>

<script>
import ListaRequisicaoProdutosSelecionados
  from '@/modules/requisicao/geracao/lista-selecao-requisicao-produtos/ListaRequisicaoProdutosSelecionados.vue';
import ListaRequisicaoProdutoListOptions
  from '@/modules/requisicao/geracao/lista-selecao-requisicao-produtos/ListaRequisicaoProdutoListOptions.vue';
import ListaRequisicaoProdutoFiltros from './ListaRequisicaoProdutoFiltros.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    produtos: Array,
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    onRemove(produtoResquisicao) {
      this.$emit('remove', produtoResquisicao);
    },
  },
  computed: {
    searchText: {
      get() {
        return this.$store.getters['requisicaoGeracao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('requisicaoGeracao/searchText', searchText);
      },
    },
  },
  components: {
    pxListaRequisicaoProdutoFiltros: ListaRequisicaoProdutoFiltros,
    pxListaRequisicaoProdutosSelecionados: ListaRequisicaoProdutosSelecionados,
    pxListaRequisicaoProdutoListOptions: ListaRequisicaoProdutoListOptions,
  },
};
</script>
